import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import SEO from "../pages/SEO";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/fr/connexion", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-void flex items-center justify-center" data-testid="auth-callback">
      <SEO noindex title="Connexion | HollowCorp" />
      <div className="flex items-center gap-3 font-mono-tech text-sm uppercase tracking-[0.2em] text-zinc-400">
        <Loader2 size={18} className="animate-spin text-acid" /> Connexion…
      </div>
    </div>
  );
}
